<template>
  <div class="pt-3 h-100">
    <common ref="common" />
    <v-toolbar dark v-if="memberModel.id">
      <v-list-item-title class="title">
        Advance
      </v-list-item-title>
      <v-btn icon large @click="closedialog()" class="d-flex justify-right">
        <v-icon>mdi-36px mdi-chevron-left</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="parties.length">
    <!-- <div v-for="(sc,sIndex) in parties" :key="sIndex"> -->
      <v-expansion-panels popout v-model="panelOpened">
        <v-expansion-panel  v-for="(sc,sIndex) in parties" :key="sIndex">
          <v-expansion-panel-header>
            <div class="d-flex justify-space-between pr-4">
              <h5>{{ sc.schemeName }}</h5>
              <h5>{{"₹"+ sc.schemeAmount }}</h5>
            </div>
            </v-expansion-panel-header>
          <v-expansion-panel-content>
            <SchemeDetails :sdtl="sc"/>
          </v-expansion-panel-content>          
        </v-expansion-panel>
      </v-expansion-panels>
    <!-- </div> -->
  </div>
    <div v-else class="h-100 d-flex align-center justify-center">
      <div class="d-flex flex-column align-center justify-center">
      <img
            src="@/assets/undraw_join_re_w1lh.svg"
            height="150"
            width="150"
            contain
          />
          <!-- <h2 class="font-weight-medium text-center">No Schemes</h2> -->
          <p class="mt-4">Hi {{ $store.getters.name }}, you haven't picked a scheme yet!</p>
        </div>
    </div>
    <div> <v-card-title class="mt-4" style="padding-left: 25px;">  Beneficiaries  </v-card-title></div>
    <div class="pt-1 h-100">
      <v-row class="pt-1 ma-0">
        <v-col style="overflow: auto;">
          <v-card
            v-for="(sub, index) in survivorList"
            v-bind:key="index"
            class="mx-auto rounded-xl mb-2 ma-1"
            :elevation="$vuetify.theme.dark ? 24 : 5"
            max-width="100%"
          >
            <v-row no-gutters class="pt-1 pb-0 ma-0">
              <v-col cols="7">
                <v-card-subtitle class="font-weight-bold">
                  {{ sub.membername }}
                </v-card-subtitle>
              </v-col>
              <v-col cols="5"> 
                      <v-card-actions class="pt-0 pb-0">
                    <v-btn
                      color="green"
                      text
                      rounded
                      x-large
                      @click="getDetails(sub)"
                    >
                      ₹
                      {{ formatNumber(sub.net_amount) }}
                    </v-btn>
                   
                  </v-card-actions>
               </v-col>
              <v-col cols="10">
                <v-card-subtitle class="text-left">
                  <!-- {{ formatDate(sub.date) }} -->
                    {{ sub.shop_name }}
                </v-card-subtitle>
              </v-col>
              <v-col cols="2" class="pt-2">
              <v-spacer></v-spacer>
                    <v-btn icon @click="getDetails(sub)">
                      <v-icon>mdi-arrow-expand-all</v-icon>
                    </v-btn>
                  </v-col>
            </v-row>
           
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
        transition="dialog-transition"
        v-model="showDetail"
        @keydown.esc="showDetail = false"
        persistent
        scrollable
      >
        <v-card class="rounded-xl" elevation="24">
          <v-card-title>
            <label> Settlement Details</label>
            <v-spacer></v-spacer>
            <v-btn icon @click="showDetail = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters class="pt-1 pb-0 ma-0">
              <v-col cols="12" class="pt-2 pl-2">
               
                <v-row class="pt-3 text-left font-weight-bold"> <v-icon class="pr-2"> mdi-calendar-clock</v-icon>{{ formatDate(showDetailModel.date) }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold" ><v-icon class="pr-2">mdi-numeric</v-icon>{{ showDetailModel.number }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold"><v-icon class="pr-2">mdi-checkbox-marked-circle</v-icon>{{ showDetailModel.particluar }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold"><v-icon class="pr-2">mdi-factory</v-icon>{{ showDetailModel.shop_name }}</v-row>
                <v-row class="pt-3  text-left font-weight-bold"><v-icon class="pr-2">mdi-map-marker-radius</v-icon>{{ showDetailModel.branch_name }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold"><v-icon class="pr-2">mdi-cellphone-basic</v-icon>{{ showDetailModel.mobile_no }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold"><v-icon class="pr-2">mdi-cash</v-icon>{{ showDetailModel.paymode }}</v-row>
                <v-row class="pt-3 text-left font-weight-bold"><v-icon class="pr-2">mdi-note-text</v-icon>{{ showDetailModel.remarks }}</v-row>
                <!-- <v-row class="text-left font-weight-bold">{{ showDetailModel.scheme_name }}</v-row> -->
               

                <!-- <v-spacer></v-spacer> -->
                <!-- <v-card-subtitle class="font-weight-bold">
                  
                </v-card-subtitle> -->
              </v-col>
              <!-- <v-card-title class="pr-8 text-right font-weight-bold"> <v-col >  ₹
                {{ formatNumber(showDetailModel.net_amount) }}</v-col></v-card-title> -->

              

              <!-- <v-col cols="12">
                <v-card-subtitle class="text-left font-weight-bold">
                    {{ showDetailModel.shop_name }}
                </v-card-subtitle>
              </v-col> -->
            </v-row>
          </v-card-text>
          <v-card-title class="font-weight-bold justify-end" >
            <v-col cols="6" style="text-align: end;"> ₹ {{ formatNumber(showDetailModel.net_amount) }} </v-col>
          </v-card-title>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import common from "@/components/tools/common";
import { callApi } from "@/api/others";
import dayjs from "dayjs";
import SchemeDetails from "@/components/wesupport/scheme/SchemeDetails.vue"
export default {
  components: { common, SchemeDetails },
  props: {
    memberModel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    propDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showDetailModel:{},
      showDetail: false,
      disableSave: false,
      parties: [],
      partyLoading: false,
      survivorList: [],
      survivorLoading: false,
      cards: [],
      cardLoading: false,
      cardBased: false,
      member: {},
      model: {},
      dialog: this.propDialog,
      types: [],
      isNew: true,
      memberLoading: false,
      members: [],
      ledgers: [],
      ledgerLoading: false,
      tranTypes: [],
      tranTypeLoading: false,
      contra: "d358da74-520b-11e9-99ad-0242ac110003",
      payModes: [],
      payModeLoading: false,
      bRectModes: {
        Cash: "fca1ef70-f4a3-11e9-b6a1-0242ac110005",
        RTGSNEFT: "0b8ef8bc-7e32-11ea-bef6-0242ac110004",
      },
      locations: [],
      locationLoading: false,
      panelOpened:1
    };
  },
  watch: {
    "model.tranformId": function(val, old) {
      if (val !== old && val !== null && val !== undefined) {
        if (this.isNew) {
          this.getNumber();
        }
        this.gettranTypes();
      }
    },
    "model.memberId": function(val, old) {
      var self = this;
      if (val !== old && val !== null && val !== undefined) {
        if (self.members.length > 0) {
          self.model.ledgerId = self.members.filter(
            (x) => x.id === val
          )[0].ledgerId;
        }
      }
    },
    "model.cardId": function(val, old) {
      if (
        val !== old &&
        val !== null &&
        val !== undefined &&
        val !== "00000000-0000-0000-0000-000000000000"
      ) {
        if (this.cards.length !== 0) {
          var card = this.cards.filter((x) => x.id === val)[0];
          var ledger = card.ledgerName;
          this.model.ledgerId = card.ledgerId;
          this.getParty(ledger);
          this.partyChangeTrigger();
        }
      }
    },
  },
  created() {
    this.member = this.memberModel;
    this.initModel();
  },
  mounted() {
    this.$emit("setBottomNav", 3);
    this.$emit("changeHeader","Schemes");
    this.fetchCardBased();
    this.fetchCombos();
    this.getNumber();
    this.getSurvivorList();
  },
  methods: {
    getDetails(model) {
        this.showDetail = true;
        this.showDetailModel=model;
        this.showDetailModel.particluar=model.particluars[0];
    },
    formatDate(d) {
      return dayjs(d).format("DD-MM-YYYY");
    },
    async fetchCardBased() {
      // await this.getSettings("Member", "Validation", "CardBased", this);
      // var result = { ...this.settingsQModel };
      // this.cardBased = JSON.parse(result.value.toLowerCase());
      if (this.cardBased) this.getcards();
    },
    async getcards() {
      var self = this;
      var common = this.$refs.common;
      this.cardLoading = true;
      var url =
        "/api/wesupport/CardMaster/getcardsByMember?memberId=" +
        this.model.memberId +
        "&isGuest=" +
        this.model.isGuest;
      await callApi(url, "get", "")
        .then((response) => {
          self.cards = response.data;
          self.cardLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          self.cards = [];
          self.cardLoading = false;
        })
        .finally(() => (self.cardLoading = false));
    },
    async getSurvivorList() {
      var self = this;
      var common = this.$refs.common;
      this.cardLoading = true;
      var url =
        "/api/wesupport/GeneralBill/getSurvivorList";
      await callApi(url, "get", "")
        .then((response) => {
          self.survivorList = response.data;
          self.survivorLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          self.survivorList = [];
          self.survivorLoading = false;
        })
        .finally(() => (self.survivorLoading = false));
    },
    onSave() {
      var self = this;
      var common = self.$refs.common;
      self.isSaveButtonDisable = true;
      self.model.date = dayjs(self.model.date).format("YYYY-MM-DD HH:mm:ss");
      if (self.model.cashBankLedgerId === "") {
        self.model.cashBankLedgerId = "00000000-0000-0000-0000-000000000000";
      }
      if (self.model.cardId === null) {
        self.model.cardId = "00000000-0000-0000-0000-000000000000";
      }
      this.disableSave = true;
      var url = "/api/wesupport/ExcessReceiptPayment/add";
      callApi(url, "post", self.model)
        .then((response) => {
          common.ManageResponse(response);
          self.isSaveButtonDisable = false;
          if (response.data.statusCode === 200) {
            self.clear();
            setTimeout(() => {
              self.closedialog();
            }, 1500);
          }
        })
        .catch((error) => {
          self.isSaveButtonDisable = false;
          common.ManageResponse(error.response);
        });
    },
    fetchCombos() {
      this.getParty("");
      // this.getTypes();
      // this.memberChange("*");
      //this.bankChange();
      // this.getpayModes();
    },
    clear() {
      this.initModel();
      this.fetchCombos();
      this.disableSave = false;
    },
    getpayModes() {
      var common = this.$refs.common;
      this.payModeLoading = true;
      var url =
        "/api/wesupport/GeneralMaster/getAllbycondition?type=PayMode&excludeCondn=Card";
      callApi(url, "get", "")
        .then((response) => {
          this.payModes = response.data;
          this.payModeLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          this.payModeLoading = false;
        });
      this.payModeLoading = false;
    },
    getTypes() {
      var self = this;
      var common = self.$refs.common;
      var url = "/api/wesupport/ExcessReceiptPayment/getTypes";
      var data = {
        displayName: "Receipt-Waiter",
      };
      callApi(url, "post", data)
        .then((response) => {
          self.types = response.data.data;
          if (self.isNew) {
            self.model.tranformId = self.types[0].id;
          }
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
    getNumber() {
      var self = this;
      if (
        self.model.tranformId !== "00000000-0000-0000-0000-000000000000" &&
        self.model.tranformId !== null &&
        self.model.tranformId !== undefined &&
        self.isNew
      ) {
        var common = self.$refs.common;
        var url =
          "/api/wesupport/ExcessReceiptPayment/getNumber?tranformId=" +
          self.model.tranformId;
        callApi(url, "get", "")
          .then((response) => {
            self.model.number = response.data.data;
          })
          .catch((error) => {
            common.ManageResponse(error.response);
          });
      }
    },
    async getParty(query) {
      var self = this;
      var common = this.$refs.common;
      this.partyLoading = true;
      var url = `/api/wesupport/SchemeEnrollment/GetSchemeEnrolledListByMemberId?MemberId=${this.decryptMemId()}`;
      await callApi(url, "get", "",true)
        .then((response) => {
          self.parties = response.data.data;
          self.partyLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          self.parties = [];
          self.partyLoading = false;
        })
        .finally(() => (self.partyLoading = false));
    },
    partyChangeTrigger() {
      var self = this;
      var mems = self.parties.filter((x) => x.id === self.model.ledgerId)[0];
      if (mems) self.model.memberId = mems.memberId;
      if (self.cardBased && mems) {
        self.model.isGuest = mems.guestType;
        if (self.cards.length > 0 && self.model.isGuest) {
          var crd = self.cards.filter(
            (x) => x.ledgerId === self.model.ledgerId
          )[0];
          if (crd) self.model.cardId = crd.id;
        }
      }
    },
    memberChange(query) {
      var self = this;
      var common = self.$refs.common;
      self.memberLoading = true;
      var url = "/api/wesupport/Member/autocomplete?searchQuery=" + query;
      if (!self.model.isReceipt) {
        url = "/api/accounts/ledger/getallwithGroup?group=SundryCreditors";
      } else {
        url = "/api/wesupport/Member/autocomplete?searchQuery=" + query;
      }
      callApi(url, "get", "")
        .then((response) => {
          self.members = response.data;
          if (self.member.id !== undefined) {
            self.model.memberId = self.members.filter(
              (x) => x.id === self.member.id
            )[0].id;
          }
          self.memberLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          self.members = [];
          self.memberLoading = false;
        })
        .finally(() => (self.memberLoading = false));
    },
    bankChange() {
      var self = this;
      var common = this.$refs.common;
      this.ledgerLoading = true;
      var url = "/api/accounts/ledger/getallwithGroup?group=Bank";
      callApi(url, "get", "")
        .then((response) => {
          self.ledgers = response.data;
          self.ledgerLoading = false;
        })
        .catch((error) => {
          self.ledgers = [];
          self.ledgerLoading = false;
          common.ManageResponse(error.response);
        })
        .finally(() => (self.ledgerLoading = false));
    },
    ledgerChange(query) {
      var self = this;
      var common = self.$refs.common;
      self.ledgerLoading = true;
      var url =
        "/api/accounts/ledger/getautowithtype?searchQuery=" +
        query +
        "&vocherType=" +
        self.contra;
      callApi(url, "get", "")
        .then((response) => {
          self.ledgers = response.data;
          self.ledgerLoading = false;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
          self.ledgers = [];
          self.ledgerLoading = false;
        })
        .finally(() => (self.ledgerLoading = false));
    },
    gettranTypes() {
      var self = this;
      var common = self.$refs.common;
      self.tranTypeLoading = true;
      if (
        self.model.tranformId !== "00000000-0000-0000-0000-000000000000" &&
        self.model.tranformId !== null
      ) {
        var url =
          "/api/wesupport/ExcessTransactionTypes/GetByEntryType?entryTypeId=" +
          self.model.tranformId;
        callApi(url, "get", "")
          .then((response) => {
            self.tranTypes = response.data;
            if (self.isNew) {
              self.model.tranTypeId = self.tranTypes[0].id;
            }
            self.tranTypeLoading = false;
          })
          .catch((error) => {
            self.tranTypeLoading = false;
            common.ManageResponse(error.response);
          })
          .finally(() => (self.tranTypeLoading = false));
      }
    },
    closedialog() {
      this.dialog = false;
      this.$emit("update:propDialog", this.dialog);
    },
    initModel() {
      this.model = {
        memberName: "",
        contra: "",
        transactionType: "",
        entryType: "",
        id: "00000000-0000-0000-0000-000000000000",
        draftId: "00000000-0000-0000-0000-000000000000",
        approvalStatus: 0,
        version: 0.0,
        actionDate: "0001-01-01T00:00:00",
        userId: "00000000-0000-0000-0000-000000000000",
        branchId: "00000000-0000-0000-0000-000000000000",
        financialYear: 0,
        tranformId: null,
        number: "",
        date: new Date().toISOString().substring(0, 10),
        tranTypeId: null,
        isReceipt: true,
        memberId: null,
        cashBankLedgerId: "",
        amount: 0.0,
        settledAmount: 0.0,
        remarks: "",
        receiptId: "00000000-0000-0000-0000-000000000000",
        ledgerId: "",
        payModeId: "",
        time: "00:00:00",
        locationId: "",
        directPrint: false,
        mobileNumber: "",
        isGuest: false,
        cardId: null,
        guestEntranceLogId: "00000000-0000-0000-0000-000000000000",
      };
    },
  },
};
</script>
